import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

// rxjs
import { Observable } from 'rxjs';

// configuration
import { environment } from "../../environments/environment";

@Injectable({
    providedIn: 'root'
})
export class PreviewService {
    /**
     * constructor
     *
     */
    constructor(private http: HttpClient) { }

    /**
     * get preview data
     *
     * @return {Observable<any>}
     */
    public preview(): Observable<any> {
        return this.http.get(environment.api + '/preview');
    }

}
